export function UrlTokenDecode(value: string) {
    // Decode UrlTokenEncode output from .NET (check:https://referencesource.microsoft.com/#System.Web/Util/HttpEncoder.cs,0e3cb83cf51ca334)
    return window.atob(
        value
            .slice(0, -1) // Remove last character
            .replace('-', '+') // Replace - with +
            .replace('_', '/') // Replace _ with /
    );
}
